import { useTranslation } from 'react-i18next';

import { AccountingPeriodPage } from './components';
import { useGetAccountingPeriodMetadata } from '@/api/REST/accountingPeriods';
import { PageTitle } from '@/components/global/PageTitle';

export const AccountingPeriod = () => {
  const { t } = useTranslation('systemAdministrationNavigation');
  const { data: metadata } = useGetAccountingPeriodMetadata();

  // Use defaultYear from API metadata, fallback to current year if not available
  const initialYear = metadata?.defaultYear ?? new Date().getFullYear();

  return (
    <>
      <PageTitle
        title={t('SystemAdministrationAccountingPeriodYearsAndPeriods')}
      />

      <AccountingPeriodPage
        title={t('SystemAdministrationAccountingPeriodYearsAndPeriods')}
        description={t('SystemAdministrationAccountingPeriodDescription')}
        initialYear={initialYear}
      />
    </>
  );
};
